import { createTheme } from '@one-thd/sui-atomic-components';

const HouseStyleBrandOrange = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

HouseStyleBrandOrange.palette['--sui-palette-background-primary'] = '249 99 2';

export { HouseStyleBrandOrange };